<template>
  <div v-if="items?.length" class="blog-similar">
    <div v-if="title" class="blog-similar__header">
      <DefH2>{{ title }}</DefH2>
    </div>
    <DefSlider :nav="screenWidth >= 768" :pagination="true" :settings="settings">
      <div v-for="item in items" :key="item.id" class="swiper-slide">
        <BlogSimilarCard :result="item" />
      </div>
    </DefSlider>
  </div>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';
import DefH2 from '@components/Def/DefH/DefH2.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import BlogSimilarCard from '@components/Blog/BlogSimilar/BlogSimilarCard.vue';
import { computed } from 'vue';

const resultsStore = useResultsStore();

const screenWidth = useScreenWidth();
const settings = {
  slidesPerView: 1,
  spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 28,
    },
  },
};

const items = computed(() => resultsStore.blogElement?.displayProperties?.SIMILAR?.items);
const title = computed(() => resultsStore.blogElement?.displayProperties?.SIMILAR?.title);
</script>

<style lang="scss" scoped>
.blog-similar {
  &__header {
    margin-bottom: 32px;
  }
  :deep(.def-h2) {
    margin-bottom: 8px;
    @include point-md {
      margin-bottom: 12px;
    }
  }
  :deep(.def-slider__next) {
    right: 0;
    transform: translate(50%, -50%);
  }
  :deep(.def-slider__prev) {
    left: 0;
    transform: translate(-50%, -50%);
  }
}
</style>
